module.exports = __webpack_public_path__ + "static/media/southampton.f1d3529c.png";